import React from 'react'
import styled from 'styled-components'

import { media, mediaMax } from 'styles/media'

import Accordion from '../display/Accordion'
import { Section } from '../display/Landing'

const Wrapper = styled.div`
  h3 {
    font-size: 24px;
    font-weight: 300;

    ${mediaMax.md`
      font-size: 18px;
    `}
  }

  p {
    font-size: 22px;
    font-weight: 300;

    ${mediaMax.md`
      font-size: 16px;
    `}
  }
`

const SectionHeader = styled.h2`
  font-size: ${({ theme }) =>
    theme?.['-ds-font-size-xl']?.['font-size']?.value};
  font-weight: ${({ theme }) =>
    theme?.['-ds-font-size-xl']?.['font-weight']?.value};
  line-height: 1.2;
  margin-bottom: 32px;
  color: ${({ theme }) => theme?.['-ds-core-300']?.value};

  ${media.md`
    font-size: ${({ theme }) =>
      theme?.['-ds-font-size-xxl']?.['font-size']?.value};
    font-weight: ${({ theme }) =>
      theme?.['-ds-font-size-xxl']?.['font-weight']?.value};
  `}
`

export type FAQItem = {
  title: string
  content: React.ReactNode
}

type FAQProps = {
  heading?: React.ReactNode
  items: FAQItem[]
}

const FAQ = ({ heading, items }: FAQProps) => {
  return (
    <Wrapper>
      {/* @ts-ignore -- not typed yet */}
      <Section borderTop>
        <div className="row">
          <div className="col-xs-12 col-md-6">
            <SectionHeader>
              {heading || (
                <>
                  Some common <br /> questions
                </>
              )}
            </SectionHeader>
          </div>
          <div className="col-xs-12 col-md-6">
            <Accordion items={items} />
          </div>
        </div>
      </Section>
    </Wrapper>
  )
}

export default FAQ
